// extracted by mini-css-extract-plugin
module.exports = {"photo":"AlternativeEnergy_photo__3-bsO","info":"AlternativeEnergy_info__1uuIP","step":"AlternativeEnergy_step__1lSsI","wrapper":"AlternativeEnergy_wrapper__59yEw"};